import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const authToken = localStorage.getItem('authToken');
    const userData = localStorage.getItem('userData');

    // Check if user is authenticated
    const isAuthenticated = authToken && userData;

    if (!isAuthenticated) {
        // Redirect to login page with return url
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;